import * as React from 'react';
import * as styles from './styles.css';
import { Section } from '../Section';

export interface IMobileviewSimpleLayoutProps {
  gallery: React.ReactNode;
  loadMoreButton: React.ReactNode;
}

export const MobileviewSimpleLayout: React.FC<IMobileviewSimpleLayoutProps> = ({ gallery, loadMoreButton }) => {
  return (
    <div className={styles['mobile-layout']} data-testid="MobileviewSimple">
      <Section className={styles['gallery']} data-mark="gallery_construction_progress">
        {gallery}
        {loadMoreButton}
      </Section>
    </div>
  );
};
